module.exports = __webpack_public_path__ + "img/icon_gift.4c37beb3.png";